export class VerificationModel {
    BidderId: number;
    NotifyEmail: string;
    NotifyPhone: string;
    OTP: string;
    Type: string;
    Email: string;
    FirstName: string;
    LastName: string;
    UserName: string;
}